import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// 30 second timeout so requests don't hang forever
export const api = axios.create({ baseURL: API, timeout: 30000 });

const updatePendingRequests = (delta) => {
  if (typeof window === "undefined") return;
  window.__m11ApiPending = Math.max(0, Number(window.__m11ApiPending || 0) + delta);
};

api.interceptors.request.use((config) => {
  updatePendingRequests(1);
  const token = localStorage.getItem("m11_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Attach a retry counter
  config.__retryCount = config.__retryCount || 0;
  return config;
}, (error) => {
  updatePendingRequests(-1);
  return Promise.reject(error);
});

// Auto-retry transient failures (network hiccups, 502/503/504, timeouts) — max 3 attempts
api.interceptors.response.use(
  (r) => {
    updatePendingRequests(-1);
    return r;
  },
  async (err) => {
    updatePendingRequests(-1);
    if (axios.isCancel(err) || err?.code === "ERR_CANCELED") return Promise.reject(err);
    const cfg = err?.config;
    if (!cfg) return Promise.reject(err);
    const status = err?.response?.status;
    const isNetwork = !err.response; // no response = network / timeout
    const isTransient = status === 502 || status === 503 || status === 504 || status === 429;
    const isIdempotent = !cfg.method || ["get", "head", "options"].includes(String(cfg.method).toLowerCase());
    // Retry only GETs on transient errors OR any network error up to 2 times
    const shouldRetry = (isNetwork || (isTransient && isIdempotent)) && cfg.__retryCount < 2;
    if (shouldRetry) {
      cfg.__retryCount += 1;
      const delay = 400 * Math.pow(2, cfg.__retryCount - 1); // 400ms, 800ms
      await new Promise((res) => setTimeout(res, delay));
      return api(cfg);
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  // Timeout / network — Hindi friendly message
  if (err?.code === "ECONNABORTED") return "Network slow — kripya dobara try karein";
  if (!err?.response) return "Internet connection weak hai — refresh karein";
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}
